import { useEffect, useState } from 'react';
import { api, type Session } from './shared/api';
import { Busy, ErrorMessage } from './shared/ui';
import { Login } from './shell/Login';
import { Shell } from './shell/Shell';
import { useI18n } from './shared/i18n';

export default function App() {
  const { t } = useI18n();
  const [session, setSession] = useState<Session>();
  const [expired, setExpired] = useState(false);
  const [error, setError] = useState<unknown>();
  async function loadSession() {
    setError(undefined);
    try { setSession(await api<Session>('/api/auth/session')); } catch (e) { setError(e); }
  }
  useEffect(() => {
    void loadSession();
    const expire = () => setExpired(true);
    window.addEventListener('kombinas:session-expired', expire);
    return () => window.removeEventListener('kombinas:session-expired', expire);
  }, []);
  if (!session) return <div className="connection-state">{error ? <><ErrorMessage error={error} /><button onClick={() => void loadSession()}>{t('Verbindung erneut versuchen')}</button></> : <Busy label="Verbindung wird hergestellt …" />}</div>;
  const onLogin = (value: Session) => { setSession(value); setExpired(false); };
  if (!session.authenticated || !session.user) return <Login onLogin={onLogin} />;
  return <><div hidden={expired} inert={expired}><Shell key={session.user.code} session={session} onLogout={() => setSession({ authenticated: false })} /></div>{expired && <div className="session-lock"><Login onLogin={onLogin} resumeCode={session.user.code} /></div>}</>;
}
